<template>
  <div class="sub-category-container">
    <button
      type="button"
      class="sub-category-button"
      :class="{ active: currentCategory === subCategory.value }"
      @click="selectSubCategory($event, subCategory.value)"
      v-for="(subCategory, index) in subCategories"
      :key="index"
    >
      {{ $t(`message.spotlightV2.subCategories.${subCategory.value}`) }}
      <span class="count">{{ subCategory.count }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SubCategoryButton',
  props: {
    subCategories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentCategory: 'all',
    };
  },
  methods: {
    selectSubCategory($event, value) {
      this.currentCategory = value;
      this.$emit('subCategorySelected', value);
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.sub-category-container {
  margin-bottom: 32px;
  .sub-category-button {
    color: $primary-dark-text;
    background-color: $primary-light-blue;
    border: none;
    font-size: 12px;
    font-weight: bold;
    padding: 9px 14px 8px;
    border-radius: 17.5px;
    margin-right: 8px;
    margin-bottom: 8px;
    .count {
      font-weight: normal;
    }
    &:hover {
      background-color: $secondary-medium-grey;
    }
    &.active {
      background-color: $primary;
      color: $primary-light-blue;
    }
    &:focus {
      outline: none;
    }
  }
}
</style>
